export const APPLICATION_COLUMN_RULES = {
    "ro_name": {
        permissions: [
            { 
                // permission_id: 4,
                permission_code: "APPLICATION_REASSIGN"
            }
        ],
        // roles: [ROLES.ADMIN, ROLES.SUPERADMIN]
    },
    "bm_name": {
        permissions: [
            { 
                // permission_id: 4,
                permission_code: "APPLICATION_REASSIGN"
            }
        ],
        // roles: [ROLES.ADMIN, ROLES.SUPERADMIN]
    },
    "bcm_name": {
        permissions: [
            { 
                // permission_id: 4,
                permission_code: "APPLICATION_REASSIGN"
            }
        ],
        // roles: [ROLES.ADMIN, ROLES.SUPERADMIN]
    },
    "parent_stage_name": {
        permissions: [
            { 
                // permission_id: 4,
                permission_code: "CHANGE_APPLICATION_STAGE"
            }
        ],
        // roles: [ROLES.ADMIN, ROLES.SUPERADMIN]
    },
    "application_stage_name": {
        permissions: [
            { 
                // permission_id: 4,
                permission_code: "CHANGE_APPLICATION_STAGE"
            }
        ],
        // roles: [ROLES.ADMIN, ROLES.SUPERADMIN]
    },
    "view_application": {
        permissions: [
            { 
                permission_code: "SINGLE_APPLICATION_VIEW"
            }
        ],
    },
    "delete_application": {
        permissions: [
            { 
                permission_code: "APPLICATION_DELETE"
            }
        ],
    },
    "download_applications_report": {
        permissions: [
            {
                permission_code: "DOWNLOAD_APPLICATIONS_REPORT"
            }
        ]
    }
};

export const OFFICER_APPLICATION_FILTERS = [
    { key: 'application_id', label: 'Application ID', type: 'text', defaultValue: "" },
    { key: 'customer_name', label: 'Customer Name', type: 'text', defaultValue: "" },
    // { key: 'customer_pan', label: 'Customer PAN', type: 'text' },
    // { key: 'phone_number', label: 'Phone Number', type: 'text' },
    { key: 'lead_id', label: 'Lead ID', type: 'text', defaultValue: "" },
    { key: 'seeds_id', label: 'Application Number', type: 'text', defaultValue: "" },
    { key: 'external_customer_id', label: 'Customer ID', type: 'text', defaultValue: "" },
    // { key: 'is_ro_completed', label: 'RO Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_bm_completed', label: 'BM Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_bcm_completed', label: 'BCM Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_rejected', label: 'Rejected', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    { key: 'current_application_bucket', label: 'Parent Stage', type: 'select', options: [], defaultValue: "" },
    { key: 'application_stage_name', label: 'Application Stage Name', type: 'select', options: [], defaultValue: ""
        // options: [
        //     { label: "Application Created", value: "Application Created" },
        //     { label: "Application Pending", value: "Application Pending" },
        //     { label: "Application Submitted", value: "Application Submitted" },
        //     { label: "Credit Report Pending", value: "Credit Report Pending" },
        //     { label: "Borrower Details Pending", value: "Borrower Details Pending" },
        //     { label: "Borrower Document Pending", value: "Borrower Document Pending" },
        //     { label: "Borrower Bank Pending", value: "Borrower Bank Pending" },
        //     { label: "Co-Borrower Details Pending", value: "Co-Borrower Details Pending" },
        //     { label: "Nominee Details Pending", value: "Nominee Details Pending" },
        //     { label: "Residence Details Pending", value: "Residence Details Pending" },
        //     { label: "Business Details Pending", value: "Business Details Pending" },
        //     { label: "Business Document Pending", value: "Business Document Pending" },
        //     { label: "BM_FI", value: "BM_FI" },
        //     { label: "Bm Recommendation Pending", value: "Bm Recommendation Pending" },
        //     { label: "BCM Verification Pending", value: "BCM Verification Pending" },
        //     { label: "Bcm Recommendation Pending", value: "Bcm Recommendation Pending" },
        //     { label: "Sales Data", value: "Sales Data" },
        //     { label: "Purchase Pending", value: "Purchase Pending" },
        //     { label: "Stock Details", value: "Stock Details" },
        //     { label: "Other Assets", value: "Other Assets" },
        //     { label: "Reference Pending", value: "Reference Pending" },
        //     { label: "Expense Report", value: "Expense Report" },
        //     { label: "Assets", value: "Assets" },
        //     { label: "BCM Recommendations-Business Pending", value: "BCM Recommendations-Business Pending" },
        //     { label: "Supplier Pending", value: "Supplier Pending" },
        //     { label: "TVR Borrower Verification Pending", value: "TVR Borrower Verification Pending" },
        //     { label: "TVR Business Reference Verification Pending", value: "TVR Business Reference Verification Pending" },
        //     { label: "TVR Informal Reference Verification Pending", value: "TVR Informal Reference Verification Pending" },
        //     { label: "Sanction Pending", value: "Sanction Pending" },
        //     { label: "Disbursal Pending", value: "Disbursal Pending" },
        //     { label: "eSign Requested", value: "eSign Requested" },
        //     { label: "eSign Completed", value: "eSign Completed" },
        //     { label: "Bureau Reject", value: "Bureau Reject" },
        //     { label: "Manual Rejected", value: "Manual Rejected" },
        //     { label: "Reject Via Admin", value: "Reject Via Admin" },
        //     { label: "Reject Via BM", value: "Reject Via BM" },
        //     { label: "Reject Via BCM", value: "Reject Via BCM" },
        //     { label: "Reject Via RO", value: "Reject Via RO" },
        //     { label: "Reject Via Sanction", value: "Reject Via Sanction" },
        //     { label: "Reject Via Account", value: "Reject Via Account" },
        //     { label: "Reject Via Other", value: "Reject Via Other" },
        //     { label: "Loan Created", value: "Loan Created" },
        // ]
    },
    { key: 'application_owner', label: 'Application Owner/Stage Bucket', type: 'select', options: [
        { label: "Pending in RO", value: "PENDING_IN_RO" },
        { label: "Pending in BM", value: "PENDING_IN_BM" },
        { label: "Pending in BCM", value: "PENDING_IN_BCM" },
        { label: "Pending in HO", value: "PENDING_IN_HO" },
        { label: "Rejected", value: "REJECTED" },
        { label: "Active Customer", value: "ACTIVE_CUSTOMER" },
        { label: "Onboarding In Progress Customer", value: "ONBOARDING_INPROGRESS_CUSTOMER" },
    ], defaultValue: "" },
    // { key: 'ro_id', label: 'RO Employee ID', type: 'text', placeholder: 'Search by RO Employee ID', defaultValue: "" },
    { key: 'ro_employee_ids', label: 'RO Employee IDs', type: 'multiselect', options: [], defaultValue: [] },
    { key: 'bm_employee_ids', label: 'BM Employee IDs', type: 'multiselect', options: [], defaultValue: [] },
    { key: 'bcm_employee_ids', label: 'BCM Employee IDs', type: 'multiselect', options: [], defaultValue: [] },
    // { key: 'branch_code', label: 'Branch Code', type: 'text', },
    { key: 'branch_code', label: 'Branch Code', type: 'select', options: [], defaultValue: "" },
    // { key: 'application_status', label: 'Application Status', type: 'select',
    //     options: [
    //         { label: "ALL", value: "ALL" },
    //         { label: "TODO", value: "TODO" },
    //         { label: "COMPLETED", value: "COMPLETED" },
    //         { label: "IN_PROGRESS", value: "IN_PROGRESS" },
    //         { label: "REJECTED", value: "REJECTED" },
    //     ]
    // },
    { key: 'sort_by', label: 'Sort By', type: 'select',
        options: [
            { label: "Created At", value: "createdAt" },
            { label: "Updated At", value: "updatedAt" },
            { label: "Lead ID", value: "lead_id" },
            { label: "First Name", value: "first_name" },
        ],
        defaultValue: ""
    },
    { key: 'sort_order', label: 'Sort Order', type: 'select',
        options: [
            { label: "Ascending", value: "ASC" },
            { label: "Descending", value: "DESC" }
        ],
        defaultValue: ""
    },
];

export const OFFICER_APPLICATION_SORT = [
    { key: 'sort_by', label: 'Sort By', type: 'select',
        options: [
            { label: "Created At", value: "createdAt" },
            { label: "Updated At", value: "updatedAt" },
            { label: "Lead ID", value: "lead_id" },
            { label: "First Name", value: "first_name" },
        ]
    },
    { key: 'sort_order', label: 'Sort Order', type: 'select',
        options: [
            { label: "Ascending", value: "ASC" },
            { label: "Descending", value: "DESC" }
        ]
    },
];


export const AUDIT_TRAIL_FILTERS = [
    { key: 'application_id', label: 'Application ID', type: 'text' },
    // { key: 'action', label: 'Action', type: 'text' },
    { key: 'action_type', label: 'Action Type', type: 'select', options: [
        { label: "STATUS CHANGE", value: "STATUS_CHANGE" },
        { label: "CREATE", value: "CREATE" },
        { label: "UPDATE", value: "UPDATE" },
        { label: "REVIEW", value: "REVIEW" },
        { label: "ASSIGN", value: "ASSIGN" },
        { label: "VERIFICATION", value: "VERIFICATION" },
        { label: "DOCUMENT UPLOAD", value: "DOCUMENT_UPLOAD" },
        { label: "DOCUMENT DELETE", value: "DOCUMENT_DELETE" },
    ] },
    { key: 'action_by_type', label: 'Action By Type', type: 'select', options: [
        { label: "OFFICER", value: "OFFICER" },
        { label: "USER", value: "USER" },
    ] },
    // { key: 'officer_id', label: 'Officer ID', type: 'text' },
    // { key: 'from_date', label: 'Start Date', type: 'date' },
    // { key: 'to_date', label: 'End Date', type: 'date' },
    { key: 'from_date', label: 'Date Range', type: 'date_range', startKey: 'from_date', endKey: 'to_date' },
    { key: 'splitter', label: 'Group By', type: 'select',
        options: [
            { label: "Day", value: "day" },
            { label: "Month", value: "month" },
            { label: "Year", value: "year" },
            { label: "Hour", value: "hour" },
        ]
    },
    { key: 'sort_order', label: 'Sort By Created Date', type: 'select',
        options: [
            { label: "Ascending", value: "ASC" },
            { label: "Descending", value: "DESC" }
        ]
    },
];

export const REJECTED_APPLICATION_COLUMN_RULES = {
    "ro_name": {
        permissions: [],
    },
    "bm_name": {
        permissions: [],
    },
    "bcm_name": {
        permissions: [],
    },
    "parent_stage_name": {
        permissions: [],
    },
    "application_stage_name": {
        permissions: [],
    },
    "re_enable": {
        permissions: [
            { 
                permission_code: "RE_ENABLE_REJECTED_APPLICATION"
            }
        ],
    },

};

export const SINGLE_APPLICATION_TAB_RULES = {
    "view_overview": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_OVERVIEW"
            }
        ]
    },
    "view_borrower_details": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BORROWER_DETAILS"
            }
        ]
    },
    "view_co_borrower_details": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_CO_BORROWER_DETAILS"
            }
        ]
    },
    "view_ro_uploads": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_RO_UPLOADS"
            }
        ]
    },
    "view_bm_uploads": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BM_UPLOADS"
            }
        ]
    },
    "view_bcm_uploads": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BCM_UPLOADS"
            }
        ]
    },
    "view_business_details": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BUSINESS_DETAILS"
            }
        ]
    },
    "view_business_finance": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BUSINESS_FINANCE"
            }
        ]
    },
    "view_limit_calculations": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_LIMIT_CALCULATIONS"
            }
        ]
    },
    "view_cb_report": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_CB_REPORT"
            }
        ]
    },
    "view_hh_credit_assessment": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_HH_CREDIT_ASSESSMENT"
            }
        ]
    },
    "view_supplier_details": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_SUPPLIER_DETAILS"
            }
        ]
    },
    "view_sanction": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_SANCTION"
            }
        ]
    },
    "view_tvr": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_TVR"
            }
        ]
    },
    "view_disbursement": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_DISBURSEMENT"
            }
        ]
    },
    "view_audit_trail": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_AUDIT_TRAIL"
            }
        ]
    },
    "view_bm_bcm_recommendations": {
        permissions: [
            {
                permission_code: "APPLICATION_VIEW_BM_BCM_RECOMMENDATIONS"
            }
        ]
    },
    "repull_cb_report": {
        permissions: [
            {
                permission_code: "REPULL_CB_REPORT"
            }
        ]
    }
}

export const TAB_CONFIG = [
  {
    label: "Overview",
    rule: "view_overview"
  },
  {
    label: "Borrower",
    rule: "view_borrower_details"
  },
  {
    label: "Co-Borrower",
    rule: "view_co_borrower_details"
  },
  {
    label: "Business",
    rule: "view_business_details"
  },
  {
    label: "Finance",
    rule: "view_business_finance"
  },
  {
    label: "Uploads-RO",
    rule: "view_ro_uploads"
  },
  {
    label: "Uploads-BM",
    rule: "view_bm_uploads"
  },
  {
    label: "Uploads-BCM",
    rule: "view_bcm_uploads"
  },
  {
    label: "CB",
    rule: "view_cb_report"
  },
  {
    label: "Credit",
    rule: "view_hh_credit_assessment"
  },
  {
    label: "Supplier",
    rule: "view_supplier_details"
  },
  {
    label: "TVR",
    rule: "view_tvr"
  },
  {
    label: "Sanction",
    rule: "view_sanction"
  },
  {
    label: "Limit Approved Details",
    rule: "view_disbursement"
  },
  {
    label: "Audit-Trail",
    rule: "view_audit_trail"
  },
  {
    label: "Analysis",
    rule: "view_bm_bcm_recommendations"
  }
];


export const DELETED_APPLICATION_COLUMN_RULES = {
    "ro_name": {
        permissions: [],
    },
    "bm_name": {
        permissions: [],
    },
    "bcm_name": {
        permissions: [],
    },
    "parent_stage_name": {
        permissions: [],
    },
    "application_stage_name": {
        permissions: [],
    },
};

export const DELETED_APPLICATIONS_FILTERS = [
    { key: 'application_id', label: 'Application ID', type: 'text' },
    { key: 'customer_name', label: 'Customer Name', type: 'text' },
    { key: 'customer_pan', label: 'Customer PAN', type: 'text' },
    { key: 'phone_number', label: 'Phone Number', type: 'text' },
    { key: 'lead_id', label: 'Lead ID', type: 'text' },
    { key: 'seeds_id', label: 'Seeds ID', type: 'text' },
    // { key: 'external_customer_id', label: 'Customer ID', type: 'text' },
    { key: 'branch_name', label: 'Branch Name', type: 'text' },
    { key: 'branch_code', label: 'Branch Code', type: 'text' },
    // { key: 'is_ro_completed', label: 'RO Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_bm_completed', label: 'BM Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_bcm_completed', label: 'BCM Process Completed', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'is_rejected', label: 'Rejected', type: 'select', 
    //     options: [
    //         { label: "YES", value: true },
    //         { label: "NO", value: false },
    //     ]
    // },
    // { key: 'application_status', label: 'Application Status', type: 'select', options: [
    //     { label: "ALL", value: "ALL"},
    //     { label: "IN_PROGRESS", value: "IN_PROGRESS"},
    //     { label: "COMPLETED", value: "COMPLETED"},
    //     { label: "REJECTED", value: "REJECTED"},
    // ] },
    { key: 'current_application_bucket', label: 'Parent Stage', type: 'select', options: [] },
    { key: 'application_stage_name', label: 'Application Stage Name', type: 'select', options: []},
    { key: 'ro_employee_ids', label: 'RO Employee IDs', type: 'multiselect', options: [] },
    { key: 'bm_employee_ids', label: 'BM Employee IDs', type: 'multiselect', options: [] },
    { key: 'bcm_employee_ids', label: 'BCM Employee IDs', type: 'multiselect', options: [] },
    { key: 'sort_by', label: 'Sort By', type: 'select',
        options: [
            { label: "Created At", value: "createdAt" },
            { label: "Updated At", value: "updatedAt" },
            { label: "Lead ID", value: "lead_id" },
            { label: "First Name", value: "first_name" },
        ]
    },
    { key: 'sort_order', label: 'Sort Order', type: 'select',
        options: [
            { label: "Ascending", value: "ASC" },
            { label: "Descending", value: "DESC" }
        ]
    },
]

// These text fields render via FilterFieldRenderer inside CBRepullTriggerModal.jsx
// as plain read-only display fields, not filters - hideSearchIcon suppresses the
// search icon FilterFieldRenderer defaults to for filter search boxes.
export const CB_REPORT_REPULL_FIELDS = [
    {
        key: 'application_id',
        label: 'Application ID',
        type: 'text',
        isMandatory: false,
        isReadOnly: true,
        isDisabled: true,
        hideSearchIcon: true
    },
    {
        key: 'applicant_name',
        label: 'Applicant Name',
        type: 'text',
        isMandatory: false,
        isReadOnly: true,
        isDisabled: true,
        hideSearchIcon: true
    },
    { 
        key: 'last_pull_date', 
        label: 'Last Pull Date', 
        type: 'date', 
        isMandatory: false, 
        isReadOnly: true,
        isDisabled: true  
    },
    // { 
    //     key: 'cost_warning', 
    //     label: 'Cost Warning', 
    //     type: 'text', 
    //     isMandatory: false, 
    //     isReadOnly: true 
    // },
    { 
        key: 'reason', 
        label: 'Reason for re-pull', 
        type: 'select', 
        isMandatory: true,
        options: [
            { label: "Phone number changed", value: "Phone number changed" },
            { label: "Address changed", value: "Address changed" },
            { label: "DOB corrected", value: "DOB corrected" },
            { label: "PAN updated", value: "PAN updated" },
            { label: "Name corrected", value: "Name corrected" },
            { label: "Other", value: "Other" },
        ] 
    },
];

export const REJECTED_APPLICATIONS_COMPONENTS = {
    applications_view: {
        permissions: [{ permission_code: "VIEW_REJECTED_APPLICATIONS" }],
    },
    download: {
        permissions: [{ permission_code: "DOWNLOAD_REJECTED_APPLICATIONS" }],
    },
    global_search: {
        permissions: [{ permission_code: "REJECTED_APPLICATIONS_SEARCH" }],
    },
    filters: {
        permissions: [{ permission_code: "REJECTED_APPLICATIONS_FILTERS" }],
    },
}

export const TEAM_DASHBOARD_SUMMARY_FILTERS = [
    { key: 'startDate', label: 'Start Date', type: 'date', defaultValue: "" },
    { key: 'endDate', label: 'End Date', type: 'date', defaultValue: "" },
    { key: 'branch_code', label: 'Branch Code', type: 'select', options: [], defaultValue: "" },
]

export const  POST_SANCTION_DOCUMENT_PROCESSING_QUEUE_FILTERS = [
    { 
        key: 'application_id', 
        label: 'Application ID', 
        type: 'text', 
        defaultValue: '' 
    },
    { 
        key: 'document_name', 
        label: 'Document Name', 
        type: 'select',
        options: [
            { key: 'kfs', label: "KFS", value: 'kfs' },
            { key: 'loan-agreement', label: "Loan Agreement", value: 'loan-agreement' },
            { key: 'sanction-letter', label: "Sanction Letter", value: 'sanction-letter' },
        ],
        defaultValue: '' 
    },
    { 
        key: 'status', 
        label: 'Status', 
        type: 'select', 
        options: [
            { key: 'pending', label: "Pending", value: 'PENDING' },
            { key: 'manual', label: "Manual", value: 'MANUAL' },
            { key: 'processing', label: "Processing", value: 'PROCESSING' },
            { key: 'success', label: "Success", value: 'SUCCESS' },
        ],
        default: ''
    },
];